import { useSelector } from 'react-redux';
import _omit from 'lodash.omit';
import _pick from 'lodash.pick';

const useSalesFrontConfig = () => {
  const { config } = useSelector(state => state);
  const { builderData } = useSelector(state => state.data);

  return {
    brand: builderData.brand.name,
    id: Math.random() * (100000 - 1) + 1,
    title: builderData.name,
    specialPrice: builderData.specialPrice,
    price: builderData.price,
    priceExVat: false,
    purchasePrice: 0,
    specification: {
      make: _omit(builderData.brand, ['iri']),
      model: { ...builderData.model, group: '', type: '' },
      body: {
        id: builderData.body.id,
        name: builderData.body.name,
        bodyStyle: builderData.body.style,
        seatsNumber: builderData.body.seats,
        doorsNumber: builderData.body.doors,
      },
      engine: builderData.engine,
      grade: { ...builderData.grade, bigPicture: '' },
      exterior: {
        ..._omit(
          builderData.exteriors.find(item => item.code === config.colorCode),
          ['pictures', 'leasingPrice']
        ),
        tilePicture: builderData.exteriors.find(item => item.code === config.colorCode)?.pictures
          ?.thumb,
        bigPicture: builderData.exteriors.find(item => item.code === config.colorCode)?.pictures
          ?.main,
        discountedPrice: 0,
        priceAdjustment: 0,
        purchasePrice: 0,
        vat: 0,
      },
      interior: {
        ..._omit(
          builderData.interior,
          ['pictures']
        ),
        tilePicture: builderData.interior.pictures?.thumb,
        bigPicture: builderData.interior.pictures?.main,
        discountedPrice: 0,
        priceAdjustment: 0,
        purchasePrice: 0,
        vat: 0,
      },
      endItemCode: config.specification,
      equipments: builderData.equipment.map(eq => ({
        ...eq,
        included: false,
        source: '',
        price: 0,
        discountedPrice: 0,
        code: '',
        vat: 0,
        type: 1,
      })),
      options: [],
      accessories: [],
      services: [],
    },
  };
};

export default useSalesFrontConfig;
